import { render, staticRenderFns } from "./PurchaseDialog.vue?vue&type=template&id=0bf91581&scoped=true"
import script from "./PurchaseDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDialog.vue?vue&type=style&index=0&id=0bf91581&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf91581",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf91581')) {
      api.createRecord('0bf91581', component.options)
    } else {
      api.reload('0bf91581', component.options)
    }
    module.hot.accept("./PurchaseDialog.vue?vue&type=template&id=0bf91581&scoped=true", function () {
      api.rerender('0bf91581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equityPopup/PurchaseDialog.vue"
export default component.exports